<div class="flex items-center gap-3">
  <div
    class="flex items-center justify-between gap-4 border border-shikenso-pink-base rounded-full px-[6px] py-0.5 w-fit"
  >
    <div class="flex items-center gap-1">
      <app-icon-badge
        [content]="creator()?.icon"
        [fallbackText]="creator()?.name"
        [size]="20"
        [iconSize]="20"
        [fontSize]="12"
        [borderRadius]="100"
      />
      <span class="text-sm">{{ creator()?.name }}</span>
    </div>
  </div>

  <div
    class="flex items-center"
    matTooltipPosition="above"
    [matTooltip]="
      existingCtaForm()?.invalid
        ? ('pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.modeCannotBeChanged' | translate)
        : ''
    "
    [matTooltipDisabled]="existingCtaForm()?.valid"
  >
    <button
      mat-flat-button
      type="button"
      color="secondary"
      class="mat-micro-button"
      [disabled]="existingCtaForm()?.invalid"
      (click)="disableCustomMode()"
    >
      <div class="flex items-center gap-2">
        <app-icon src="icons/door-exit.svg" [size]="16" />
        <span class="text-xs">
          {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.creatorSelectMenu.exitOverride' | translate }}
        </span>
      </div>
    </button>
  </div>
</div>
